/* Timbrica — /moon. Луна: 3D-глобус с настоящей либрацией, фаза, лунный день.
 *
 * ЧЕМ ЭТОТ ТУЛ ОТЛИЧАЕТСЯ ОТ ВСЕХ ОСТАЛЬНЫХ (это не украшения, а суть):
 *
 * 1. СФЕРА НЕ «ПОДКРУЧЕНА ПОД ФАЗУ». Сцена — настоящая геометрия: Земля в нуле,
 *    Луна и Солнце в своих геоцентрических векторах, тело ориентировано моделью
 *    вращения МАС. Фаза, терминатор и либрация получаются САМИ и не могут
 *    разойтись между собой. Сторож — тест, который считает освещённость из
 *    геометрии сцены и сверяет с движком (tests/js/astro-ephemeris.test.mjs).
 *
 * 2. ЛИБРАЦИЯ ВИДНА. Луна качается ±8°, из-за чего с Земли доступно 59 %
 *    поверхности, а не 50 %. Плоские картинки фазы этого не показывают в
 *    принципе. У нас край, который сегодня «выглянул», реально выглядывает.
 *
 * 3. СЕРП ПОВЁРНУТ КАК В НЕБЕ. Все рисуют «рожки вбок» — это вид из учебника.
 *    В небе наклон зависит от места и времени (параллактический угол). Режим
 *    «как в небе» ставит терминатор ровно так, как человек увидит с балкона;
 *    «как на карте» — север сверху, для сверки с атласом.
 *
 * 4. ЛУННЫЙ ДЕНЬ ОТ ВОСХОДА В ТОЧКЕ ПОЛЬЗОВАТЕЛЯ. Лунные сутки меняются в
 *    момент восхода Луны, а не в полночь. Печатные календари считают для Москвы
 *    и печатают на всю страну — во Владивостоке это врёт на сутки.
 *
 * 5. ПРИПОЛЯРЬЕ НЕ ЗАМАЛЧИВАЕТСЯ. Где Луна не взошла, мы говорим об этом, а не
 *    показываем прочерк как будто данных просто нет.
 *
 * Вся астрономия — в astro-ephemeris.js (общая с /solar-system и /eclipse-tracker).
 * Здесь только сцена, панели и взаимодействие.
 */
(function () {
  'use strict';

  var C = window.MOON_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var AC = window.AstroEphemeris;
  var A = window.Astronomy;
  if (!AC || !A) {
    // Ядро не приехало — молчать нельзя: страница выглядела бы «просто пустой».
    var host = $('mnScene');
    if (host) host.innerHTML = '<div class="mn-err">' + tr('engine_failed') + '</div>';
    ae('tool_error', { slug: 'moon', reason: 'astro_core_missing' });
    return;
  }

  var DAY_MS = 86400000;
  var DEG = Math.PI / 180;

  // ── Состояние ───────────────────────────────────────────────────────────────

  var state = {
    when: new Date(),
    live: true,                         // тикать в реальном времени
    place: { lat: C.home.lat, lon: C.home.lon, label: C.home.label || '', fromGeo: false },
    view: 'sky',                        // 'sky' — как в небе, 'map' — север сверху
    calMonth: new Date()
  };

  // ── Форматирование ──────────────────────────────────────────────────────────

  // Время показываем в поясе МЕСТА, а не браузера: если человек смотрит на
  // Владивосток из Москвы, «восход в 21:14» должен быть владивостокским.
  // Точный пояс знаем только когда точка пришла от геолокации (это сам
  // пользователь) — иначе честно берём долготный сдвиг.
  function tzOffsetMin() {
    if (state.place.fromGeo) return -new Date().getTimezoneOffset();
    return Math.round(state.place.lon / 15) * 60;
  }
  function fmtTime(d) {
    if (!d) return '—';
    var shifted = new Date(d.getTime() + tzOffsetMin() * 60000);
    try {
      return shifted.toLocaleTimeString(C.locale, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
    } catch (e) { return shifted.toISOString().slice(11, 16); }
  }
  function fmtDate(d) {
    if (!d) return '—';
    var shifted = new Date(d.getTime() + tzOffsetMin() * 60000);
    try {
      return shifted.toLocaleDateString(C.locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    } catch (e) { return shifted.toISOString().slice(0, 10); }
  }
  function fmtNum(x, digits) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 0 }); }
    catch (e) { return Number(x).toFixed(digits || 0); }
  }
  function countdown(ms) {
    var s = Math.max(0, ms / 1000);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    if (d > 0) return d + tr('d_short') + ' ' + h + tr('h_short');
    if (h > 0) return h + tr('h_short') + ' ' + m + tr('m_short');
    return m + tr('m_short');
  }

  // ── 3D-сцена ────────────────────────────────────────────────────────────────

  var three = null, renderer = null, scene3 = null, camera = null, moonMesh = null,
    sunLight = null, THREE = null, sceneReady = false, userDrag = { x: 0, y: 0 }, dragging = false;

  function sceneHost() { return $('mnScene'); }

  /** Убрать плоскую канву — в контейнере должен быть ровно один рисовальщик. */
  function removeFlat() {
    var f = $('mnFlat');
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }

  function initThree() {
    var host = sceneHost();
    if (!host) return Promise.resolve(false);
    // ⚠️ Список, а не адрес: свой origin первым, зеркало вторым. До 13.08.2026
    // сюда приходила пара {primary, fallback}, и код брал ТОЛЬКО primary —
    // запасной путь лежал в конфиге страницы и никем не читался. На intl-локалях
    // primary вёл на jsdelivr, а «запасной» адрес на NL отдавал 404: обещание
    // было двойным, и обе его половины были ложью.
    var urls = (C.three && C.three.length) ? C.three : [];
    if (!urls.length) return Promise.resolve(false);
    var chain = window.__assetChain;
    var load = chain ? chain.importModule(urls, 'three') : import(urls[0]);
    return load.then(function (mod) {
      THREE = mod;
      var m0 = measure(), w = m0.w, h = m0.h;
      try {
        // preserveDrawingBuffer: после композитинга содержимое буфера WebGL не
        // гарантировано, и любое чтение канвы (drawImage/toDataURL) возвращает
        // мусор — на этом сломалась первая версия пиксельной проверки. Сцена
        // перерисовывается раз в минуту, так что цена нулевая, а взамен канву
        // можно честно прочитать и сохранить картинкой.
        renderer = new THREE.WebGLRenderer({
          antialias: true, alpha: true, powerPreference: 'low-power', preserveDrawingBuffer: true
        });
      } catch (e) { return false; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(w, h);
      host.appendChild(renderer.domElement);
      renderer.domElement.setAttribute('aria-label', tr('canvas_aria'));

      scene3 = new THREE.Scene();
      // Ортографическая камера: Луна далеко, перспективы там нет. С перспективной
      // край диска «раздувается» и терминатор врёт на пару процентов.
      camera = new THREE.OrthographicCamera(-1.15, 1.15, 1.15, -1.15, 0.01, 100);
      camera.position.set(0, 0, 10);
      // ⚠️ Фрустум ОБЯЗАН учитывать соотношение сторон канвы. Квадратный фрустум
      // на прямоугольной канве растягивает диск, и Луна получается овалом,
      // вылезающим за край, — ровно это и было видно на первом скриншоте.
      applyFrustum(w, h);

      var geo = new THREE.SphereGeometry(1, 96, 64);
      var loader = new THREE.TextureLoader();
      var tex = loader.load(C.tex.base, function () { render3(); },
        undefined, function () { ae('tool_error', { slug: 'moon', reason: 'texture_failed' }); });
      if ('colorSpace' in tex) tex.colorSpace = THREE.SRGBColorSpace;

      // Ламберт, а не физический материал: реголит почти не бликует, а PBR добавил
      // бы паразитный блик в центре диска — его на Луне нет.
      var mat = new THREE.MeshLambertMaterial({ map: tex });
      moonMesh = new THREE.Mesh(geo, mat);
      scene3.add(moonMesh);

      sunLight = new THREE.DirectionalLight(0xfff6e8, 3.1);
      scene3.add(sunLight);
      // Крошечная подсветка «пепельного света» — Земля реально освещает ночную
      // сторону, и полностью чёрный диск выглядит как дырка в странице.
      scene3.add(new THREE.AmbientLight(0x3b4a66, 0.10));

      bindDrag(renderer.domElement);
      // iOS отнимает WebGL-контекст (фон, нехватка памяти), а three.js узнаёт об этом
      // только из СОБЫТИЯ webglcontextlost — WebKit доставляет его, когда вызовы GL уже
      // отказывают: createShader() → null, и WebKit бросает на shaderSource(null)
      // (Sentry TIMBRICA-FRONTEND-MZ, iPhone, минутный тик). Пока контекста нет —
      // плоская Луна; вернулся — снова 3D.
      renderer.domElement.addEventListener('webglcontextlost', sceneLost, false);
      renderer.domElement.addEventListener('webglcontextrestored', sceneBack, false);
      sceneReady = true;
      removeFlat();          // плоский путь мог успеть нарисоваться до этого момента

      window.addEventListener('resize', onResize, { passive: true });
      return true;
    }).catch(function () { return false; });
  }

  // Диск занимает 87 % меньшей стороны и НЕ деформируется на любой канве.
  function applyFrustum(w, h) {
    // Половина высоты фрустума. Сфера радиуса 1 займёт (1/r) кадра по меньшей
    // стороне: 1.28 → ~78 %, диск не липнет к краям и остаётся место чипсам
    // управления снизу. Замерено скриншотом, не подобрано на глаз.
    var r = 1.28, a = (w && h) ? w / h : 1;
    if (a >= 1) { camera.left = -r * a; camera.right = r * a; camera.top = r; camera.bottom = -r; }
    else { camera.left = -r; camera.right = r; camera.top = r / a; camera.bottom = -r / a; }
    camera.updateProjectionMatrix();
  }

  function measure() {
    var host = sceneHost();
    // Квадрат считаем от ШИРИНЫ, а не от clientHeight: на первом кадре высота
    // ещё не разрешена из aspect-ratio и приходит нулём. Фолбэк 480 в этом
    // случае делал канву прямоугольной и ломал кадр (поймано скриншотом).
    var w = host.clientWidth || host.parentElement.clientWidth || 420;
    var h = Math.round(w);
    return { host: host, w: w, h: h };
  }

  function onResize() {
    if (!sceneReady) return;
    var m = measure();
    renderer.setSize(m.w, m.h);
    applyFrustum(m.w, m.h);
    render3();
  }

  function bindDrag(el) {
    var last = null;
    function down(e) { dragging = true; last = pt(e); el.style.cursor = 'grabbing'; }
    function move(e) {
      if (!dragging || !last) return;
      var p = pt(e);
      userDrag.x += (p.x - last.x) * 0.4;
      userDrag.y += (p.y - last.y) * 0.4;
      userDrag.y = Math.max(-89, Math.min(89, userDrag.y));
      last = p; render3();
      if (e.cancelable) e.preventDefault();
    }
    function up() { dragging = false; last = null; el.style.cursor = 'grab'; }
    function pt(e) { var t = e.touches ? e.touches[0] : e; return { x: t.clientX, y: t.clientY }; }
    el.style.cursor = 'grab';
    el.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    el.addEventListener('touchstart', down, { passive: true });
    el.addEventListener('touchmove', move, { passive: false });
    el.addEventListener('touchend', up);
  }

  /**
   * Ставит сцену по настоящим векторам на state.when.
   *
   * ⚠️ Здесь была ошибка, которую поймал ТОЛЬКО скриншот: камера ставилась вдоль
   * геоцентрического вектора Луны, и диск уезжал за край кадра. Профиль пикселей
   * показал, что в центре канвы Луны нет вообще. Числовые проверки этого не
   * видели — они мерили физику, а не кадр.
   *
   * Устойчивая схема: КАДР И ФИЗИКА РАЗВЕДЕНЫ.
   *   - камера неподвижна в (0,0,6), смотрит в начало координат → диск всегда
   *     ровно по центру, при любой дате и любом месте;
   *   - вся физика уходит в ПОВОРОТ ТЕЛА и НАПРАВЛЕНИЕ СВЕТА, пересчитанные в
   *     систему наблюдателя.
   * Фаза, терминатор и либрация от этого не меняются — меняется только то, что
   * кадрирование больше не может сломаться.
   */
  // Синхронный ответ «контекста нет» — раньше события, которое опаздывает.
  function glLost() {
    try { return !renderer || renderer.getContext().isContextLost(); } catch (e) { return true; }
  }
  function sceneLost() {
    if (!sceneReady) return;
    sceneReady = false;
    renderer.domElement.style.display = 'none';
    render2D();
    ae('feature_use', { slug: 'moon', feature: 'gl_lost' });
  }
  function sceneBack() {
    if (sceneReady || !renderer || glLost()) return;
    renderer.domElement.style.display = '';
    sceneReady = true;
    removeFlat();
    render3();
  }

  function render3() {
    if (!sceneReady) return;
    if (glLost()) { sceneLost(); return; }
    var sc = AC.moonScene(state.when, state.place.lat, state.place.lon, 0);

    var toMoon = new THREE.Vector3(sc.toMoon.x, sc.toMoon.y, sc.toMoon.z).normalize();
    var toSun = new THREE.Vector3(sc.toSun.x, sc.toSun.y, sc.toSun.z).normalize();
    var north = new THREE.Vector3(sc.northPole.x, sc.northPole.y, sc.northPole.z).normalize();

    // Система наблюдателя: +Z смотрит на камеру (то есть на Землю), +Y — север
    // Луны, спроецированный поперёк взгляда.
    var vZ = toMoon.clone().negate();                       // Луна → Земля
    var vY = north.clone().sub(vZ.clone().multiplyScalar(north.dot(vZ)));
    if (vY.lengthSq() < 1e-8) vY.set(0, 1, 0);              // вырожденный случай
    vY.normalize();
    var vX = new THREE.Vector3().crossVectors(vY, vZ).normalize();
    var view = new THREE.Matrix4().makeBasis(vX, vY, vZ);   // мир → наблюдатель
    var viewInv = view.clone().transpose();                 // ортонормированная

    // Ориентация тела Луны в мире: из полюса и угла собственного вращения W
    // (модель вращения МАС). Либрация уже внутри — добавлять её отдельно не надо.
    var bZ = north.clone();
    var ref = Math.abs(bZ.z) > 0.9 ? new THREE.Vector3(1, 0, 0) : new THREE.Vector3(0, 0, 1);
    var bX = new THREE.Vector3().crossVectors(ref, bZ).normalize();
    var bY = new THREE.Vector3().crossVectors(bZ, bX).normalize();
    var body = new THREE.Matrix4().makeBasis(bX, bY, bZ);
    body.multiply(new THREE.Matrix4().makeRotationZ((sc.spinDeg + 90) * DEG));
    // Сфера three.js кладёт текстуру полюсами по оси Y, а наша ось тела — Z.
    body.multiply(new THREE.Matrix4().makeRotationX(Math.PI / 2));

    // Тело переводим в систему наблюдателя, затем добавляем ручной доворот и
    // (в режиме «как в небе») параллактический наклон.
    var m = new THREE.Matrix4().multiplyMatrices(viewInv, body);
    var extra = new THREE.Matrix4();
    if (state.view === 'sky' && sc.limb) {
      extra.multiply(new THREE.Matrix4().makeRotationZ(sc.limb.q * DEG));
    }
    if (userDrag.x || userDrag.y) {
      extra.multiply(new THREE.Matrix4().makeRotationY(userDrag.x * DEG * 0.6));
      extra.multiply(new THREE.Matrix4().makeRotationX(userDrag.y * DEG * 0.6));
    }
    moonMesh.setRotationFromMatrix(new THREE.Matrix4().multiplyMatrices(extra, m));

    // Свет — то же преобразование, иначе терминатор поедет относительно тела.
    var lightDir = toSun.clone().applyMatrix4(viewInv);
    lightDir.applyMatrix4(extra);
    sunLight.position.copy(lightDir.multiplyScalar(50));

    camera.position.set(0, 0, 6);
    camera.up.set(0, 1, 0);
    camera.lookAt(0, 0, 0);
    renderer.render(scene3, camera);
  }

  function resetView() { userDrag.x = 0; userDrag.y = 0; render3(); ae('feature_use', { slug: 'moon', feature: 'reset_view' }); }

  // ── Плоский запасной путь ───────────────────────────────────────────────────

  // Без WebGL страница обязана остаться полезной: рисуем диск с терминатором
  // на 2D-канве. Текстуры нет, но фаза, наклон и размер — настоящие.
  function render2D() {
    var host = sceneHost();
    if (!host) return;
    // ⚠️ Если WebGL уже поднялся — плоский путь ОБЯЗАН молчать. Иначе в контейнере
    // оказываются ДВЕ канвы, flex ставит их рядом, каждая ужимается вдвое, и
    // Луна выглядит гигантской и уехавшей за край. Именно так и было: числовые
    // тесты этого не видят, поймал профиль пикселей со скриншота.
    if (sceneReady) { removeFlat(); return; }
    var cv = $('mnFlat');
    if (!cv) {
      cv = document.createElement('canvas'); cv.id = 'mnFlat';
      cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', tr('canvas_aria'));
      host.appendChild(cv);
    }
    var size = Math.min(host.clientWidth || 320, host.clientHeight || 320);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = size * dpr; cv.height = size * dpr;
    cv.style.width = size + 'px'; cv.style.height = size + 'px';
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, size, size);

    var s = AC.moonSnapshot(state.when, state.place.lat, state.place.lon, 0);
    var r = size * 0.42, cx = size / 2, cy = size / 2;
    var tilt = state.view === 'sky' && s.limb ? (s.limb.chi - s.limb.q) : s.limb ? s.limb.chi : 0;

    g.save(); g.translate(cx, cy); g.rotate(-tilt * DEG);
    g.beginPath(); g.arc(0, 0, r, 0, Math.PI * 2); g.fillStyle = '#1b2233'; g.fill();
    // Освещённая часть — круг, срезанный эллипсом терминатора.
    var k = Math.cos(s.phaseDeg * DEG);       // −1 полнолуние … +1 новолуние
    g.save(); g.beginPath(); g.arc(0, 0, r, 0, Math.PI * 2); g.clip();
    g.beginPath();
    g.ellipse(0, 0, Math.abs(r * k), r, 0, 0, Math.PI * 2);
    var lit = new Path2D();
    lit.arc(0, 0, r, -Math.PI / 2, Math.PI / 2);
    g.fillStyle = '#d8d3c8';
    g.beginPath();
    g.arc(0, 0, r, -Math.PI / 2, Math.PI / 2, s.waxing);
    g.ellipse(0, 0, Math.abs(r * k), r, 0, Math.PI / 2, -Math.PI / 2, (k > 0) !== s.waxing);
    g.closePath(); g.fill();
    g.restore(); g.restore();
  }

  // ── Панели ──────────────────────────────────────────────────────────────────

  function phaseName(key) { return tr('phase_' + key); }

  function renderNow() {
    var s = AC.moonSnapshot(state.when, state.place.lat, state.place.lon, 0);

    setText('mnPhaseName', phaseName(s.phaseKey));
    setText('mnIllum', fmtNum(s.illumination * 100, 1) + '%');
    setText('mnAge', s.ageDays == null ? '—' : fmtNum(s.ageDays, 1) + ' ' + tr('days_short'));
    setText('mnDist', fmtNum(s.distanceKm, 0) + ' ' + tr('km'));
    setText('mnDiam', fmtNum(s.angularDiameterDeg * 60, 1) + '′');
    setText('mnZodiac', tr('zod_' + s.zodiac.key) + ' ' + fmtNum(s.zodiac.degInSign, 0) + '°');
    setText('mnLibLon', (s.libration.lon >= 0 ? '+' : '') + fmtNum(s.libration.lon, 1) + '°');
    setText('mnLibLat', (s.libration.lat >= 0 ? '+' : '') + fmtNum(s.libration.lat, 1) + '°');

    // Супер/микролуние — только когда это правда, а не «ярлык ради ярлыка».
    var badge = $('mnBadge');
    if (badge) {
      if (s.apsis && s.apsis.isSuper) { badge.textContent = tr('supermoon'); badge.className = 'mn-badge super'; badge.hidden = false; }
      else if (s.apsis && s.apsis.isMicro) { badge.textContent = tr('micromoon'); badge.className = 'mn-badge micro'; badge.hidden = false; }
      else badge.hidden = true;
    }

    // Лунный день — главная русская фича. Приполярье не замалчиваем.
    var obs = AC.observer(state.place.lat, state.place.lon, 0);
    var ld = null;
    try { ld = AC.lunarDay(state.when, obs); } catch (e) { ld = null; }
    if (ld) {
      setText('mnLunarDay', String(ld.day));
      setText('mnLunarSpan', fmtTime(ld.start) + ' — ' + (ld.end ? fmtTime(ld.end) : '…'));
    } else {
      setText('mnLunarDay', '—');
      setText('mnLunarSpan', tr('no_moonrise'));
    }

    // Высота и азимут сейчас — «где смотреть».
    setText('mnAlt', fmtNum(s.altitude, 1) + '°');
    setText('mnAz', fmtNum(s.azimuth, 0) + '° ' + compassPoint(s.azimuth));
    var vis = $('mnVisible');
    if (vis) vis.textContent = s.altitude > 0 ? tr('above_horizon') : tr('below_horizon');

    return s;
  }

  function compassPoint(az) {
    var pts = tr('compass').split(',');
    return pts[Math.round(((az % 360) + 360) % 360 / 45) % 8] || '';
  }

  function renderTimes() {
    var t;
    try { t = AC.moonTimes(state.when, state.place.lat, state.place.lon, 0); }
    catch (e) { t = { rise: null, set: null, transit: null }; }
    setText('mnRise', t.rise ? fmtTime(t.rise) : tr('no_event'));
    setText('mnSet', t.set ? fmtTime(t.set) : tr('no_event'));
    setText('mnTransit', t.transit ? fmtTime(t.transit) : tr('no_event'));
    setText('mnTransitAlt', t.transitAltitude == null ? '—' : fmtNum(t.transitAltitude, 0) + '°');
  }

  function renderPhases() {
    var box = $('mnPhaseList');
    if (!box) return;
    var qs = AC.nextQuarters(state.when, 4);
    var names = ['phase_new', 'phase_first_quarter', 'phase_full', 'phase_last_quarter'];
    box.innerHTML = '';
    qs.forEach(function (q) {
      var row = document.createElement('div');
      row.className = 'mn-row';
      row.innerHTML = '<span class="mn-row-n">' + escapeHtml(tr(names[q.quarter])) + '</span>' +
        '<span class="mn-row-d">' + escapeHtml(fmtDate(q.date) + ', ' + fmtTime(q.date)) + '</span>' +
        '<span class="mn-row-z">' + escapeHtml(countdown(q.date - state.when)) + '</span>';
      box.appendChild(row);
    });

    // Перигей и апогей — они объясняют, почему диск то крупнее, то мельче.
    var s = AC.moonSnapshot(state.when, state.place.lat, state.place.lon, 0);
    if (s.apsis && s.apsis.perigeeDate) {
      setText('mnPerigee', fmtDate(s.apsis.perigeeDate) + ' · ' + fmtNum(s.apsis.perigeeKm, 0) + ' ' + tr('km'));
    }
    if (s.apsis && s.apsis.apogeeDate) {
      setText('mnApogee', fmtDate(s.apsis.apogeeDate) + ' · ' + fmtNum(s.apsis.apogeeKm, 0) + ' ' + tr('km'));
    }
  }

  // Календарь месяца: фаза на каждый день. Именно его ищут запросом
  // «лунный календарь», и он же переводит человека в конкретную дату.
  function renderCalendar() {
    var box = $('mnCal');
    if (!box) return;
    var y = state.calMonth.getFullYear(), m = state.calMonth.getMonth();
    var first = new Date(y, m, 1);
    var days = new Date(y, m + 1, 0).getDate();
    // Понедельник первым — так в 8 из 9 наших локалей; для en сдвиг на воскресенье.
    var weekStart = (C.locale === 'en') ? 0 : 1;
    var lead = (first.getDay() - weekStart + 7) % 7;

    setText('mnCalTitle', first.toLocaleDateString(C.locale, { month: 'long', year: 'numeric' }));
    box.innerHTML = '';
    for (var i = 0; i < lead; i++) box.appendChild(document.createElement('div'));

    var todayKey = ymd(new Date()), selKey = ymd(state.when);
    for (var d = 1; d <= days; d++) {
      var date = new Date(y, m, d, 12, 0, 0);
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'mn-cal-day';
      if (ymd(date) === todayKey) cell.classList.add('today');
      if (ymd(date) === selKey) cell.classList.add('sel');
      var ph = A.MoonPhase(date);
      cell.innerHTML = '<span class="mn-cal-n">' + d + '</span>' + phaseGlyph(ph);
      cell.setAttribute('aria-label', d + ' — ' + phaseName(AC.PHASE_KEYS[AC.phaseIndex(ph)]));
      (function (dd) {
        cell.addEventListener('click', function () {
          state.live = false;
          // Сохраняем время суток — иначе клик по календарю телепортирует в полдень
          // и «восход луны» меняется без причины.
          var keep = state.when;
          state.when = new Date(dd.getFullYear(), dd.getMonth(), dd.getDate(),
            keep.getHours(), keep.getMinutes(), 0);
          syncLiveButton(); renderAll();
          ae('feature_use', { slug: 'moon', feature: 'calendar_pick' });
        });
      }(date));
      box.appendChild(cell);
    }
  }

  function ymd(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  // Маленький значок фазы в клетке — рисуем svg, а не эмодзи: эмодзи-фазы
  // в шрифтах отражены как в СЕВЕРНОМ полушарии и врут для южных локалей.
  function phaseGlyph(phaseDeg) {
    var k = Math.cos(phaseDeg * DEG);          // −1 полн … +1 нов
    var waxing = phaseDeg < 180;
    var r = 7, rx = Math.abs(r * k).toFixed(2);
    var sweepOuter = waxing ? 1 : 0;
    var sweepInner = ((k > 0) !== waxing) ? 1 : 0;
    var d = 'M0,' + (-r) + ' A' + r + ',' + r + ' 0 0,' + sweepOuter + ' 0,' + r +
      ' A' + rx + ',' + r + ' 0 0,' + sweepInner + ' 0,' + (-r) + ' Z';
    return '<svg class="mn-cal-ph" viewBox="-9 -9 18 18" aria-hidden="true">' +
      '<circle r="' + r + '" fill="rgba(255,255,255,.10)"/>' +
      '<path d="' + d + '" fill="#e8e2d5"/></svg>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  // ── Сборка ──────────────────────────────────────────────────────────────────

  /* Ответ считается ВЫДАННЫМ один раз за жизнь страницы: воронка обрывалась на
     'ready', то есть мы знали, что страницу открыли, и не знали, увидел ли
     человек хоть одно число. Дальше он листает дни — это уже feature_use, а не
     новые «завершения», иначе метрика превратится в счётчик кликов. */
  var answered = false;
  function markAnswered(s) {
    if (answered || !s) return;
    answered = true;
    // ⚠️ ОТЛОЖЕННО, и это не мелочь: первая отрисовка случается ВНУТРИ boot(),
    // до stage('ready'), поэтому прямой вызов давал порядок
    // load -> complete -> ready. Воронка, где ответ выдан раньше готовности,
    // не просто выглядит странно — в ней бессмысленны все задержки dwell_ms.
    setTimeout(function () { stage('complete'); }, 0);
    // Поля берём ИЗ СНАПШОТА, а не по памяти: у него phaseKey/illumination,
    // никаких phaseIndex и lunarDay здесь нет — лунный день считается отдельно
    // в renderTimes(). Придуманное имя поля уехало бы в базу как null и
    // выглядело бы как «у пользователей не считается».
    var el = $('mnLunarDay');
    ae('tool_complete', {
      slug: 'moon',
      phase: s.phaseKey,
      illum: Math.round((s.illumination || 0) * 100),
      lunar_day: el ? (parseInt(el.textContent, 10) || null) : null,
      scene: sceneReady ? '3d' : '2d',
    });
  }

  function renderAll() {
    var s = renderNow();
    renderTimes();
    renderPhases();
    renderCalendar();
    if (sceneReady) render3(); else render2D();
    setText('mnWhen', fmtDate(state.when) + ', ' + fmtTime(state.when));
    setText('mnPlace', state.place.label || (fmtNum(state.place.lat, 2) + ', ' + fmtNum(state.place.lon, 2)));
    markAnswered(s);
    return s;
  }

  function syncLiveButton() {
    var b = $('mnLive');
    if (b) { b.classList.toggle('on', state.live); b.setAttribute('aria-pressed', state.live ? 'true' : 'false'); }
  }

  function shiftDays(n) {
    state.live = false;
    state.when = new Date(state.when.getTime() + n * DAY_MS);
    state.calMonth = new Date(state.when.getFullYear(), state.when.getMonth(), 1);
    syncLiveButton(); renderAll();
  }

  function goLive() {
    state.live = true;
    state.when = new Date();
    state.calMonth = new Date(state.when.getFullYear(), state.when.getMonth(), 1);
    syncLiveButton(); renderAll();
  }

  function locate() {
    // Пустая кнопка — худший исход: раньше половина гео-тулов молча не делала
    // ничего. __geo.notify объясняет причину вслух.
    if (!navigator.geolocation) { if (window.__geo) window.__geo.notify('no_api'); return; }
    var b = $('mnLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      state.place = { lat: pos.coords.latitude, lon: pos.coords.longitude, label: tr('your_place'), fromGeo: true };
      if (b) b.disabled = false;
      renderAll();
      ae('feature_use', { slug: 'moon', feature: 'locate' });
    }, function (err) {
      if (b) b.disabled = false;
      if (window.__geo) window.__geo.notify(err);
    }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  function bind() {
    var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
    on('mnPrevDay', function () { shiftDays(-1); });
    on('mnNextDay', function () { shiftDays(1); });
    on('mnPrevMonth', function () { state.calMonth = new Date(state.calMonth.getFullYear(), state.calMonth.getMonth() - 1, 1); renderCalendar(); });
    on('mnNextMonth', function () { state.calMonth = new Date(state.calMonth.getFullYear(), state.calMonth.getMonth() + 1, 1); renderCalendar(); });
    on('mnLive', goLive);
    on('mnLocate', locate);
    on('mnReset', resetView);
    on('mnViewSky', function () { setView('sky', true); });
    on('mnViewMap', function () { setView('map', true); });
  }

  // fromUser=true only for a real click. boot() calls this too, and without
  // the split every page load filed the remembered view as a fresh choice:
  // 510 view events over 339 sessions in 30 days, and boot emits exactly one
  // per session — so about two thirds of that number was page loads. It made
  // the default look 5.0:1 more popular than the map view when the real click
  // ratio is nearer 1.6:1.
  function setView(v, fromUser) {
    state.view = v;
    var a = $('mnViewSky'), b = $('mnViewMap');
    if (a) a.classList.toggle('on', v === 'sky');
    if (b) b.classList.toggle('on', v === 'map');
    if (window.__toolSettings) window.__toolSettings.save('moon', 'view', v);
    if (sceneReady) render3(); else render2D();
    ae('feature_use', { slug: 'moon', feature: (fromUser ? 'view_' : 'view_restored_') + v });
  }

  // ── Старт ───────────────────────────────────────────────────────────────────

  function boot() {
    stage('load');
    bind();
    if (window.__toolSettings) {
      var v = window.__toolSettings.load('moon', 'view', 'sky');
      if (v === 'map' || v === 'sky') state.view = v;
    }
    setView(state.view, false);
    syncLiveButton();

    initThree().then(function (ok) {
      if (!ok) {
        var host = sceneHost();
        if (host) host.classList.add('flat');
        render2D();
        ae('tool_diagnostic', { slug: 'moon', issue: 'no_webgl' });
      }
      renderAll();
      // Первый кадр строится до того, как раскладка окончательно устоялась
      // (шрифты, сайдбар, баннеры). Один перезамер после кадра — и канва
      // получает настоящий размер вместо предположения.
      if (sceneReady) requestAnimationFrame(function () { onResize(); });
      stage('ready');
    });

    // Живой тик раз в минуту: чаще незачем — Луна за минуту сдвигается на 0.5′.
    setInterval(function () {
      if (!state.live) return;
      state.when = new Date();
      renderAll();
    }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
